import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateLetterTemplates = () => {
  const queryClient = useQueryClient();

  const invalidateLetterTemplates = () => {
    void queryClient.invalidateQueries({
      queryKey: ['globalLetterTemplates'],
    });
  };

  return { invalidateLetterTemplates };
};
